import * as Yup from "yup";
import { ToolInOutSourceType } from "features/ToolInOuts/constants/tool-in-out.constants";

const schema = Yup.object({
  toolId: Yup.number()
    .typeError("Tool is required")
    .required("Tool is required"),

  userId: Yup.number()
    .typeError("Concerned person is required")
    .required("Concerned person is required"),

  sourceType: Yup.mixed<ToolInOutSourceType>()
    .oneOf(Object.values(ToolInOutSourceType))
    .required("Source type is required"),

  sourceId: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null ? null : value,
    )
    .nullable()
    .when("sourceType", {
      is: (v: ToolInOutSourceType) => v !== ToolInOutSourceType.OTHER,
      then: (s) =>
        s
          .typeError("The source field is required")
          .required("The source field is required"),
      otherwise: (s) => s.notRequired(),
    }),

  otherDescription: Yup.string()
    .nullable()
    .when("sourceType", {
      is: ToolInOutSourceType.OTHER,
      then: (s) => s.trim().required("Description is required"),
      otherwise: (s) => s.notRequired(),
    }),

  referenceNo: Yup.string().nullable(),

  quantity: Yup.number()
    .typeError("Enter a valid quantity")
    .positive("Quantity must be greater than zero")
    .required("Quantity is required"),

  dateOut: Yup.string().nullable(),
});

export default schema;
